export type DisciplinePriorityInput = {
  exam_weight: number;
  question_weight: number;
  discipline_size: number;
  difficulty_level: number;
};

export type DisciplinePriorityResult<T extends DisciplinePriorityInput> = T & {
  normalizedExamWeight: number;
  normalizedQuestionWeight: number;
  total: number;
  percent: number;
  cycle_hours: number;
};

const oneDecimal = (value: number) => Math.round(value * 10) / 10;

// Transforma peso e quantidade de questões em uma escala comparável de 0 a 5.
// TD e ND já usam a escala 1 a 3 definida na interface.
export function calculateDisciplinePriorities<T extends DisciplinePriorityInput>(items: T[]): DisciplinePriorityResult<T>[] {
  const maxExamWeight = Math.max(1, ...items.map((item) => Number(item.exam_weight || 0)));
  const maxQuestions = Math.max(1, ...items.map((item) => Number(item.question_weight || 0)));
  const rows = items.map((item) => {
    const normalizedExamWeight = oneDecimal((Number(item.exam_weight || 0) / maxExamWeight) * 5);
    const normalizedQuestionWeight = oneDecimal((Number(item.question_weight || 0) / maxQuestions) * 5);
    const total = oneDecimal(normalizedExamWeight + normalizedQuestionWeight + Number(item.discipline_size || 0) + Number(item.difficulty_level || 0));
    return { ...item, normalizedExamWeight, normalizedQuestionWeight, total };
  });
  const grandTotal = rows.reduce((sum, item) => sum + item.total, 0) || 1;
  return rows.map((item) => ({ ...item, percent: oneDecimal((item.total / grandTotal) * 100), cycle_hours: 0 }));
}
